import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, Menu, X } from "lucide-react";
import { CONTACT } from "@/data/products";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/about", label: "About Us", testid: "nav-link-about" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
  { to: "/privacy", label: "Privacy", testid: "nav-link-privacy" },
  { to: "/disclaimer", label: "Disclaimer", testid: "nav-link-disclaimer" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 w-full z-50 bg-cream/85 backdrop-blur-md border-b border-linen">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-brand-logo" className="flex items-baseline gap-3 group">
          <span className="font-hindi text-2xl text-spice group-hover:text-spicedark transition-colors">राजकुमारी</span>
          <span className="hidden sm:block font-serif font-bold tracking-tight text-sm uppercase text-ink">
            Raj Kumari Kirana Store
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors hover:text-spice ${
                  isActive ? "text-spice" : "text-bark"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-call-btn"
            className="inline-flex items-center gap-2 bg-ink text-cream text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-spice transition-colors duration-300"
          >
            <Phone size={15} />
            {CONTACT.phone}
          </a>
        </nav>

        <button
          data-testid="nav-mobile-menu-btn"
          className="lg:hidden text-ink"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden bg-cream border-b border-linen"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  onClick={() => setOpen(false)}
                  className="font-serif text-2xl text-ink hover:text-spice transition-colors"
                >
                  {l.label}
                </NavLink>
              ))}
              <a href={CONTACT.phoneHref} className="inline-flex items-center gap-2 text-spice font-semibold pt-2">
                <Phone size={16} /> {CONTACT.phone}
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Navbar;
